import React from 'react'
import $ from 'jquery';
import ManImg from '../assets/images/testimonials_man.png'


function HappyClients() {
    $(document).ready(function(){
        $('.customer_carousel2').owlCarousel({
          loop:true,
          margin:0,
          
          autoplay:true,
          autoplayTimeout:3000,
          autoplayHoverPause:true,
          nav:false,
          dots:true,
          responsive:{
              0:{
                  items:1
              },
              320:{
                  items:1
              },
              480:{
                  items:1
              },
              600:{
                  items:1
              },
              767:{
                  items:1
              },
              991:{
                  items:1
              },
              1200:{
                  items:2
              }
          }
      });
      });	
  return (
    <section className="articles">
    <div className="container">
       <h2 className="what-we-dos"><span className="what-we-do">HAPPY</span> CLIENTS</h2>
       <hr className="animated-hrs" />
    <div className="container">
    <div class="client-bg">
	<div class="container">		
       <div class="row">
		   <ul class="customer_carousel2 owl-carousel owl-theme">
			   <li>
				   <div class="box">
					   <img src={ManImg} />
					   <h4>Executive - IT, MuSigma.</h4>
					   <p>Unique delivery by studying participants .Best wishes from us to create brand in the ATD.</p>
					   <div class="box-btn pb-3">
						   <a href="/testimonials">Read More</a>
					   </div>
				   </div>
			   </li>
			   <li>
				   <div class="box">
                   <img src={ManImg} />
					   <h4>Manager - HR, Netcon Technologies.</h4>
					   <p>Really Impresed , Subject Matter Expert , methedology and their tools .</p>
					   <div class="box-btn pb-3">
						   <a href="/testimonials">Read More</a>
					   </div>
				   </div>
			   </li>
			   <li>
				   <div class="box">
                   <img src={ManImg} />
					   <h4>Regional Director-Channel  | SAARC Region | extreme Networks</h4>
					   <p>We entrusted and awarded ATP to BRiX for PAN-india in early 2015.They have excelled by enabling 35+ Extreme Certified Specialist and 40+  extreme certified.....</p>
					   <div class="box-btn pb-3">
						   <a href="/testimonials">Read More</a>
					   </div>
				   </div>
			   </li>
		   </ul>
	   </div>
	</div>
</div>
    </div>
    </div>
 </section>
  );
}
export default HappyClients;
